import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef, NbGlobalLogicalPosition, NbToastrService } from '@nebular/theme';
import { AnalistaDataService } from '../../../../services/v1/AnalistaController/analista-data.service';
import { AccountDataService } from '../../../../services/v1/AccountController/account-data.service';
import { NbAuthService, NbTokenService, NbAuthJWTToken } from '@nebular/auth';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';

@Component({
  selector: 'ngx-mudar-perfil-usuario',
  templateUrl: './mudar-perfil-usuario.component.html',
  styleUrls: ['./mudar-perfil-usuario.component.scss']
})
export class MudarPerfilUsuarioComponent implements OnInit {
  logicalPositions = NbGlobalLogicalPosition;
  loadingUsuarios: boolean = false;
  listaUsuarios: any[] = [];
  usuarioSelecionado: string = null;
  usuarioAtualId: string = sessionStorage.getItem('usuarioId');

  // Variáveis para autocomplete do Usuário
  @ViewChild('inputUsuario', { static: false }) inputUsuario: ElementRef;
  searchUsuario: string = '';
  filteredUsuario: Array<{value: string, label: string}> = [];
  showUsuarioDropdown: boolean = false;
  dropdownTop: number = 0;
  dropdownLeft: number = 0;
  dropdownWidth: number = 0;

  constructor(
    public dialogRef: NbDialogRef<MudarPerfilUsuarioComponent>,
    private analistaService: AnalistaDataService,
    private accountDataService: AccountDataService,
    private toastrService: NbToastrService,
    private authService: NbAuthService,
    private tokenService: NbTokenService,
    private router: Router
  ) { }

  ngOnInit() {
    this.carregarUsuarios();
  }

  carregarUsuarios() {
    this.loadingUsuarios = true;
    this.analistaService.GetAnalista()
      .pipe(
        timeout(10000),
        catchError(error => {
          console.error('Erro ao carregar usuários:', error);
          this.loadingUsuarios = false;
          this.toastrService.danger('Erro ao carregar a lista de usuários', 'Erro', { position: this.logicalPositions.TOP_END });
          return of({ success: false, data: [] });
        })
      )
      .subscribe(
        value => {
          this.loadingUsuarios = false;
          if (value.success) {
            this.listaUsuarios = value.data.sort((a, b) => a.employeeName.localeCompare(b.employeeName));
            // Inicializar lista filtrada
            this.filteredUsuario = this.listaUsuarios.map(usuario => ({
              value: usuario.Id,
              label: usuario.employeeName
            }));
          } else {
            this.toastrService.warning(value.Message || 'Erro ao carregar usuários', 'Aviso', { position: this.logicalPositions.TOP_END });
          }
        },
        error => {
          this.loadingUsuarios = false;
          this.toastrService.danger(error.error?.Message || 'Erro desconhecido', 'Erro ao carregar usuários', { position: this.logicalPositions.TOP_END });
        }
      );
  }

  onSearchUsuarioInput(event: any) {
    this.searchUsuario = event.target.value;
    this.filterUsuarioOptions();
    this.showUsuarioDropdown = true;
    this.calcularPosicaoDropdown();
  }

  onUsuarioFocus(event: any) {
    this.showUsuarioDropdown = true;
    this.calcularPosicaoDropdown();
  }

  calcularPosicaoDropdown() {
    if (this.inputUsuario && this.inputUsuario.nativeElement) {
      const inputElement = this.inputUsuario.nativeElement;
      const rect = inputElement.getBoundingClientRect();
      this.dropdownTop = rect.bottom + window.scrollY + 4;
      this.dropdownLeft = rect.left + window.scrollX;
      this.dropdownWidth = rect.width;
    }
  }

  filterUsuarioOptions() {
    if (!this.searchUsuario.trim()) {
      this.filteredUsuario = this.listaUsuarios.map(usuario => ({
        value: usuario.Id,
        label: usuario.employeeName
      }));
    } else {
      const searchLower = this.searchUsuario.toLowerCase();
      this.filteredUsuario = this.listaUsuarios
        .filter(usuario => usuario.employeeName.toLowerCase().includes(searchLower))
        .map(usuario => ({
          value: usuario.Id,
          label: usuario.employeeName
        }));
    }
  }

  selectUsuarioOption(option: {value: string, label: string}) {
    this.searchUsuario = option.label;
    this.usuarioSelecionado = option.value;
    this.showUsuarioDropdown = false;
  }

  onUsuarioBlur() {
    setTimeout(() => {
      this.showUsuarioDropdown = false;
    }, 200);
  }

  trackByValue(index: number, option: {value: string, label: string}): string {
    return option.value;
  }

  mudarPerfil() {
    if (!this.usuarioSelecionado || this.usuarioSelecionado === '0') {
      this.toastrService.warning('Por favor, selecione um usuário', 'Aviso', { position: this.logicalPositions.TOP_END });
      return;
    }

    if (this.usuarioSelecionado === this.usuarioAtualId) {
      this.toastrService.info('Você já está logado com este usuário', 'Informação', { position: this.logicalPositions.TOP_END });
      this.close();
      return;
    }

    const usuarioSelecionadoObj = this.listaUsuarios.find(u => u.Id === this.usuarioSelecionado);
    if (!usuarioSelecionadoObj) {
      this.toastrService.danger('Usuário não encontrado', 'Erro', { position: this.logicalPositions.TOP_END });
      return;
    }

    // Obter email do usuário selecionado (assumindo que o objeto tem email ou userName)
    const email =usuarioSelecionadoObj.Username;
    if (!email) {
      this.toastrService.danger('Email do usuário não encontrado', 'Erro', { position: this.logicalPositions.TOP_END });
      return;
    }

    // Criar comando de autenticação com permiteTrocarUsuario = true
    const command = {
      email: email,
      password: '', // A senha será gerenciada pela API quando permiteTrocarUsuario for true
      permiteTrocarUsuario: true
    };

    // Fazer autenticação com permiteTrocarUsuario = true (skipAuth = true porque o endpoint é AllowAnonymous)
    this.accountDataService.SingIn(command, true).subscribe({
      next: (result) => {
        if (result && result.token) {
          // 1) Limpar token antigo
          this.tokenService.clear();

          // 2) Limpar todos os cookies
          document.cookie.split(';').forEach((c) => {
            document.cookie = c
              .replace(/^ +/, '')
              .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
          });

          // 3) Limpar todos os caches da aplicação (como um novo login)
          sessionStorage.clear();
          localStorage.clear();

          // 4) Gravar novo token (Nebular persiste no localStorage)
          const newToken = new NbAuthJWTToken(result.token, 'email');
          this.tokenService.set(newToken);

          // 5) Gravar dados do novo usuário no sessionStorage
          if (result.user) {
            sessionStorage.setItem('tipoUsuario', result.user.tipoUsuario || '');
            sessionStorage.setItem('usuarioId', result.user.usuarioId || '');
            sessionStorage.setItem('nomeUsuario', result.user.userName || '');
            sessionStorage.setItem('requestSenha', result.user.requestPassword || '');
          }

          this.toastrService.success(`Perfil alterado para: ${usuarioSelecionadoObj.employeeName}`, 'Sucesso', { position: this.logicalPositions.TOP_END });
          this.close();

          // 6) Recarrega na rota inicial; o PagesComponent escolhe a tela conforme perfil e permissões
          const baseHref = (document.querySelector('base')?.getAttribute('href') || '/').replace(/\/$/, '');
          const path = (baseHref === '' ? '/' : baseHref) + 'pages';
          setTimeout(() => {
            window.location.href = path;
          }, 300);
        } else {
          this.toastrService.danger('Erro ao alterar perfil', 'Erro', { position: this.logicalPositions.TOP_END });
        }
      },
      error: (error) => {
        console.error('Erro ao alterar perfil:', error);
        this.toastrService.danger(error.error?.Message || 'Erro ao alterar perfil', 'Erro', { position: this.logicalPositions.TOP_END });
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
